module.exports = __webpack_public_path__ + "62c0135163427c652ae397f327f85010.otf";